<template>

    <div class="story-wrapper" :class="{'perspective-active' : getViewPerspective != 'perspective-default'}" v-scroll-lock="bodyLock">

        <day v-for="(day, key, index) in $t('days')"
             :key="key"
             ref="day"
             :itemData="$t(day)"
             :dayIndex="index"
             @show-modal="showModal"
             @event-in-viewport="eventInViewport"
             @remove-full-width-progressbar="removeFullProgressBar"
             v-observe-visibility="{
               callback: (isVisible, entry) => dayInViewport(isVisible, entry, index ),
               intersection: {
                 rootMargin: '-200px 0px 0px 0px',
               }
             }"
        ></day>

        <div class="story-group-background first" :style="'background-image: url('+publicPath+$t('backgroundImageFirst')+');'"></div>

        <div class="story-group-background second" :style="'background-image: url('+publicPath+$t('backgroundImageSecond')+');'"></div>

        <div class="story-button-wrapper">
          <router-link :to="{ name: 'home', params: { locale: this.$i18n.locale }}" class="button light">
            <span>{{ $t('backButton') }}</span>
          </router-link>
        </div>

        <progressbar ref="progressbar" :currentDay="currentDay" @show-custom-day="scrollToDay"></progressbar>

        <modal ref="modal" class="story-group-lighbox" @unlock-body="unlockBody"></modal>

        <div class="modal static map" :class="{'active' : this.$store.getters.getterMapModalState}">

            <div class="modal-inner">

                <a class="modal-close special" href="" @click.prevent="closeModal">

                    <svg xmlns="http://www.w3.org/2000/svg" width="15.556" height="15.556" viewBox="0 0 15.556 15.556"><g id="Symbol_85_1" data-name="Symbol 85 – 1" transform="translate(-1064 -310)"><path id="Union_3" data-name="Union 3" d="M7.778,9.192,1.414,15.557,0,14.142,6.364,7.778,0,1.414,1.414,0,7.778,6.364,14.142,0l1.415,1.414L9.192,7.778l6.364,6.364-1.415,1.415Z" transform="translate(1064 310)" fill="#2699fb"/></g></svg>
                </a>

                <div class="modal-icon">

                    <svg xmlns="http://www.w3.org/2000/svg" width="190" height="190" viewBox="0 0 190 190"><defs><clipPath id="clip-path"><rect width="16" height="16" fill="none"/></clipPath></defs><g id="icon" transform="translate(-697 -109)"><g id="Ellipse_50" data-name="Ellipse 50" transform="translate(697 109)" fill="none" stroke="#2699fb" stroke-width="1" opacity="0.106"><circle cx="95" cy="95" r="95" stroke="none"/><circle cx="95" cy="95" r="94.5" fill="none"/></g><g id="Ellipse_49" data-name="Ellipse 49" transform="translate(737 149)" fill="none" stroke="#bce0fd" stroke-width="1" opacity="0.5"><circle cx="55" cy="55" r="55" stroke="none"/><circle cx="55" cy="55" r="54.5" fill="none"/></g><g id="Ellipse_48" data-name="Ellipse 48" transform="translate(762 174)" fill="#fff" stroke="#7fc4fd" stroke-width="1"><circle cx="30" cy="30" r="30" stroke="none"/><circle cx="30" cy="30" r="29.5" fill="none"/></g><g id="Symbol_5_1" data-name="Symbol 5 – 1" transform="translate(784 196)" clip-path="url(#clip-path)"><path id="Path_4" data-name="Path 4" d="M2.4,2.4A7.263,7.263,0,0,1,8,0a7.263,7.263,0,0,1,5.6,2.4A7.263,7.263,0,0,1,16,8a7.263,7.263,0,0,1-2.4,5.6A7.263,7.263,0,0,1,8,16a7.263,7.263,0,0,1-5.6-2.4A7.984,7.984,0,0,1,0,8,7.263,7.263,0,0,1,2.4,2.4Zm6.667,12a3.276,3.276,0,0,0,2-1.2A5.824,5.824,0,0,0,12,10.4a2.208,2.208,0,0,0-.667-1.6A2.347,2.347,0,0,0,9.6,8H8.267a3.893,3.893,0,0,1-1.2-.267,1.21,1.21,0,0,1-.4-.933.693.693,0,0,1,.267-.533A1.011,1.011,0,0,1,7.467,6a.91.91,0,0,1,.667.4c.267.133.4.267.533.267A.8.8,0,0,0,9.2,6.533.8.8,0,0,0,9.333,6a2.122,2.122,0,0,0-.667-1.333,5.515,5.515,0,0,0,.667-2.533.287.287,0,0,0-.267-.267A4.122,4.122,0,0,0,8,1.6,6.67,6.67,0,0,0,4.533,2.667a3.357,3.357,0,0,0-1.2,2.667A3.414,3.414,0,0,0,4.4,7.867,3.643,3.643,0,0,0,6.933,8.933h0v.533A1.712,1.712,0,0,0,7.467,10.8a1.942,1.942,0,0,0,1.2.8V14c0,.133,0,.133.133.267S8.933,14.4,9.067,14.4Z" fill="#2699fb"/></g></g></svg>
                </div>

                <div class="modal-content">
                    <Map ref="map" @show-custom-day="scrollToDay"></Map>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import Day from '@/components/Day'
import Progressbar from '@/components/Progressbar'
import Modal from '@/components/Modal'
import Map from "@/components/Map"

export default {
  name: 'Story',
  components: {
    Day,
    Map,
    Modal,
    Progressbar
  },
  data () {
    return {
      currentDay: 1,
      nextDayToShow: 2,
      publicPath: process.env.BASE_URL,
      bodyLock: false
    }
  },
  watch: {
    '$store.state.mapModalState': function() {
      this.bodyLock = this.$store.state.mapModalState
    }
  },
  computed: {
    getViewPerspective () {
      return this.$store.getters.getterViewPerspectiveValue
    }
  },
  methods: {
    scrollToDay(dayToShow, subeventId = 0){
      this.$refs.day[dayToShow].scrollToEvent(subeventId)
      this.$forceUpdate();
    },

    removeFullProgressBar () {
      this.$refs.progressbar.removeFullProgressBar()
    },
    eventInViewport (index) {
      this.$refs.progressbar.eventInViewport(index)
    },
    dayInViewport (isVisible, entry, index) {
        if (isVisible) {
            this.$refs.progressbar.dayInViewport(index)
            this.$refs.map.dayInViewport(index)
        }
        this.isVisible = entry
    },
    // showLightbox (lightboxData,type) {
    //   this.$refs.lightbox.lightboxState(lightboxData,type)
    // },
    showModal (modalData,type) {
      this.$refs.modal.modalState(modalData,type)
    },
    unlockBody () {
      let daysCounts = Object.keys(this.$refs.day).length
      for (let i = 0; i < daysCounts; i++) {
        this.$refs.day[i].unlockBody()
      }
    },
    closeModal () {
      this.$store.dispatch('updateMapModalState', false)
    }
  }
}
</script>
